import React from 'react';
import { PathSteps } from './PathSteps';
import { isolatedResources, pathSteps, skillChain } from '../data/offer';
export function SystemOverview() {
  return <section className="py-24 px-4 bg-navy text-white" data-id="element-313" data-mp="18tg4hv2a5akt">
      <div className="max-w-6xl mx-auto" data-id="element-314" data-mp="1mlmbaqjjm57l">
        <h2 className="text-3xl md:text-5xl font-display font-extrabold text-center mb-14" data-id="element-315" data-mp="1moi7a9btyjte">
          One System. Six Volumes. <span className="text-seafoam" data-id="element-316" data-mp="txqelltz4dat">Every Stage Covered.</span>
        </h2>

        <div className="grid md:grid-cols-2 gap-10 md:gap-16 mb-16" data-id="element-317" data-mp="tztdywh0nis7">
          <div data-id="element-318" data-mp="pxzhl0dut0xu">
            <p className="text-lg text-white/80 mb-4" data-id="element-319" data-mp="pyhm0kao6lgu">
              Most mountain bike resources focus on one isolated subject.
            </p>
            <ul className="space-y-2 mb-6" data-id="element-320" data-mp="ywjq58pp9u8c">
              {isolatedResources.map(item => <li key={item} className="text-lg text-white/60 line-through decoration-white/30" data-id="element-321" data-mp="2fatg279lbr1a">
                  {item}
                </li>)}
            </ul>
            <p className="text-xl font-semibold" data-id="element-322" data-mp="236e5ywticbpp">
              But real riders don’t develop in isolated pieces.
            </p>
          </div>
          <div className="md:border-l md:border-white/15 md:pl-16" data-id="element-323" data-mp="284fjl285zits">
            <ul className="space-y-3 mb-6" data-id="element-324" data-mp="2d4tnc82qg6m0">
              {skillChain.map(item => <li key={item} className="flex items-start gap-3 text-lg text-white/85" data-id="element-325" data-mp="2i3n2e4xo45oa">
                  <span className="mt-2.5 w-1.5 h-1.5 rounded-full bg-seafoam shrink-0" aria-hidden="true" data-id="element-326" data-mp="1kfweswobpo6g" />
                  {item}
                </li>)}
            </ul>
            <p className="text-lg text-white/80" data-id="element-327" data-mp="1pcv9bgbwfx56">
              And eventually, every individual skill needs to connect into confident,
              independent riding.
            </p>
          </div>
        </div>

        <div className="text-center border-t border-white/15 pt-12" data-id="element-328" data-mp="11pepz36m3cqd">
          <p className="text-xl md:text-2xl font-semibold mb-6" data-id="element-329" data-mp="11p4ytc9tyzj3">
            That’s why Mountain Bike Coach Ready is organized as a complete progression.
          </p>
          <PathSteps steps={pathSteps} tone="dark" data-id="element-330" data-mp="ymqovejpyk5y" />
        </div>
      </div>
    </section>;
}